import React, { useState, useEffect } from "react";
import {
  BellFilled,
  DownOutlined,
  LeftOutlined,
  LogoutOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Avatar, Badge, Layout, Menu } from "antd";
import SubMenu from "antd/lib/menu/SubMenu";
import Logo from "../../../assets/logo.png";
import { useNavigate, useLocation } from "react-router-dom";
import useProfile from "./useSidebar";
import { ReactComponent as DotIcon } from "../../../assets/dot.svg";
import { ReactComponent as UserIcon } from "../../../assets/user-icon.svg";
import collapsedIcon from "../../../assets/collapsed-icon.png";
import UseWindowSize from "./useWindowSize";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser, setNavbarCollapsed } from "../../login/redux/actions";
import SelectProjectsPopup from "./selectProjectsPopover";
// import NotificationChannel from "../notifications/notificationChannel";
// import Notifications from "../notifications/index";
// import { fetchUnreadNotifications } from "../notifications/notificationsRedux/notificationActions";
import { fetchAllUserProjects } from "../../UserManager/redux/actions";

const SidebarComponent = (props) => {
  const { Sider } = Layout;
  const [shouldCollapse, setShouldCollapse] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logoutLoading } = useSelector((state) => state?.authReducer);
  // const { unreadNotifications } = useSelector(
  //   (state) => state.notificationsReducer
  // );

  const dispatch = useDispatch();
  const [menuItemsData] = useProfile();
  const [SelectProjectsModalvisible, setSelectProjectsModalVisible] =
    useState(false);
  const [notificationModalvisible, setNotificationModalVisible] =
    useState(false);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const { projects } = useSelector((state) => state.authReducer);
  const { user_projects } = useSelector((state) => state.userManagerReducer);
  const { allProjects } = useSelector((state) => state.projectsSetupReducer);

  let current_role = user?.userType;

  const screenWidth = UseWindowSize();

  useEffect(() => {
    if (screenWidth < 992) {
      setShouldCollapse(false);
      setCollapsed(true);
      dispatch(setNavbarCollapsed(true));
    } else {
      setShouldCollapse(true);
    }
  }, [screenWidth]);

  useEffect(() => {
    // dispatch(fetchUnreadNotifications());
    dispatch(
      fetchAllUserProjects({ search: {}, sortedInfo: null, user_id: user.id })
    );
  }, [location.pathname]);

  let ls = localStorage.getItem("lsselectedProjects");
  useEffect(() => {
    if (ls === null) {
      setSelectedProjects([]);
    } else {
      setSelectedProjects(JSON.parse(ls));
    }
  }, [location.pathname, ls, projects, user_projects, allProjects]);

  const isSelected = (id, pathType = null) => {
    if (!pathType) {
      // For parent project selection
      let isProjectPath = location.pathname.includes("project/material-control") || 
                          location.pathname.includes("project/progress-summary");
      if (isProjectPath) {
        let urlID = location.pathname.split("/").slice(-1)[0];
        return urlID == id ? true : false;
      } else {
        return false;
      }
    } else {
      // For specific menu item selection (Material Control or Progress Summary)
      let urlID = location.pathname.split("/").slice(-1)[0];
      return location.pathname.includes(`project/${pathType}`) && urlID == id ? true : false;
    }
  };

  const handleSelectedKey = () => {
    if (location.pathname.includes("/settings/users-manager/create-user")) {
      return "/settings/users-manager";
    }
    if (location.pathname.includes("/settings/users-manager/update-user")) {
      return "/settings/users-manager";
    }
    if (location.pathname.includes("/settings/project-statuses")) {
      return "/settings/project-statuses";
    }
    if (location.pathname.includes("/settings/project-statuses")) {
      return "/settings/project-statuses";
    }
    if (location.pathname.includes("/settings/revision-statuses")) {
      return "/settings/revision-statuses";
    }
    if (location.pathname.includes("/settings/clients-manager/create-client")) {
      return "/settings/clients-manager";
    }
    if (location.pathname.includes("/settings/clients-manager/update-client")) {
      return "/settings/clients-manager";
    }
    if (location.pathname.includes("/settings/material-templates/create-template")) {
      return "/settings/material-templates";
    }
    if (location.pathname.includes("/settings/material-templates/update-template")) {
      return "/settings/material-templates";
    }
    if (location.pathname.includes("/projects-setup/create-project")) {
      return "/projects-setup";
    }
    if (location.pathname.includes("/projects-setup/update-project")) {
      return "/projects-setup";
    }

    if (location.pathname.includes("/project/material-control")) {
      return `/project/material-control`;
    }
    
    if (location.pathname.includes("/project/progress-summary")) {
      return `/project/progress-summary`;
    }

    if (location.pathname === "/") {
      let path = current_role !== "client" ? "/profile" : "/client-profile";
      navigate(path);
      return path;
    }

    return location.pathname;
  };

  const handleLogout = () => {
    dispatch(logoutUser({ navigate, id: user.id }));
  };

  const ProjectsList = () => {
    return selectedProjects.map((project, i) => {
      const { client, projectNumber, id } = project.project;
      
      // Find user permissions for this project
      const projectPermission = user_projects?.find(up => up.projectId === id)?.permissions;
      const hasViewPermission = projectPermission?.general?.view;
      
      let materialControlLink = `/project/material-control/${id}`;
      let progressSummaryLink = `/project/progress-summary/${id}`;
      let deliveryNotesLink = `/project/delivery-notes/${id}`;
      let className = isSelected(id) ? "project-doc-selected" : "";
      let parentClass = isSelected(id) ? "project-doc-selected-parent" : "";
      let materialControlMenuKey = `project/${id}/material-control`;
      let progressSummaryMenuKey = `project/${id}/progress-summary`;
      let deliveryNotesMenuKey = `project/${id}/delivery-notes`;

      return (
        <SubMenu
          className={`menu-item-for-top-border${
            collapsed ? "-collapsed" : ""
          } projects-submenu ${parentClass}`} // projects-subitems-custom
          key={id}
          eventKey={id}
          // onTitleClick={(e) => console.log("e", e.key, key)}
          icon={
            <DotIcon
              fill="#ffffff"
              className="projects-submenu-bullet"
              style={{
                width: "10px",
                height: "10px",
                fontSize: "10px",
                margin: collapsed ? "0px" : "0px 15px 0px 0px",
              }}
            />
          }
          title={
            // !collapsed && (
            <div style={{ height: "auto", minHeight: "50px", paddingBottom: "10px" }}>
              <div
                className="project-name"
                style={{ 
                  width: "180px", 
                  maxWidth: "180px",
                  lineHeight: "16px", 
                  fontSize: "14px",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                  overflow: "visible",
                  wordBreak: "break-word",
                  hyphens: "auto",
                  paddingTop: "12px"
                }}
              >
                <span style={{
                  display: "block",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  maxWidth: "100%"
                }}>{projectNumber}</span>
              </div>
              <div
                className="client-name"
                style={{
                  width: "180px",
                  maxWidth: "180px",
                  lineHeight: "14px",
                  fontSize: "11px",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                  overflow: "visible"
                }}
              >
                <span
                  style={{
                    display: "block",
                    wordWrap: "break-word",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    maxWidth: "100%"
                  }}
                >
                  {client}
                </span>
              </div>
            </div>
            // )
          }
        >
          {hasViewPermission && (
            <>
              <Menu.Item
                onClick={() => navigate(materialControlLink)}
                className={`subitems-custom projects-subitems-custom ${isSelected(id, 'material-control') ? 'project-doc-selected' : ''}`}
                key={materialControlMenuKey} // link
                style={{
                  padding: collapsed ? `0px !important` : "0px 15px 0px 45px",
                  paddingLeft: collapsed ? "10px" : "45px",
                  color: isSelected(id, 'material-control') ? '#f25003' : '#ffffff',
                }}
                icon={
                  <DotIcon
                    fill={isSelected(id, 'material-control') ? "#f25003" : "#ffffff"}
                    className="dot-icon"
                    style={{
                      margin: collapsed ? "0px" : "0px 5px 0px 0px",
                    }}
                  />
                }
              >
                Material Control
              </Menu.Item>
              <Menu.Item
                onClick={() => navigate(deliveryNotesLink)}
                className={`subitems-custom projects-subitems-custom ${isSelected(id, 'delivery-notes') ? 'project-doc-selected' : ''}`}
                key={deliveryNotesMenuKey} // link
                style={{
                  padding: collapsed ? `0px !important` : "0px 15px 0px 45px",
                  paddingLeft: collapsed ? "10px" : "45px",
                  color: isSelected(id, 'delivery-notes') ? '#f25003' : '#ffffff',
                }}
                icon={
                  <DotIcon
                    fill={isSelected(id, 'delivery-notes') ? "#f25003" : "#ffffff"}
                    className="dot-icon"
                    style={{
                      margin: collapsed ? "0px" : "0px 5px 0px 0px",
                    }}
                  />
                }
              >
                Delivery Notes Register
              </Menu.Item>
              <Menu.Item
                onClick={() => navigate(progressSummaryLink)}
                className={`subitems-custom projects-subitems-custom ${isSelected(id, 'progress-summary') ? 'project-doc-selected' : ''}`}
                key={progressSummaryMenuKey}
                style={{
                  padding: collapsed ? `0px !important` : "0px 15px 0px 45px",
                  paddingLeft: collapsed ? "10px" : "45px",
                  color: isSelected(id, 'progress-summary') ? '#f25003' : '#ffffff',
                }}
                icon={
                  <DotIcon
                    fill={isSelected(id, 'progress-summary') ? "#f25003" : "#ffffff"}
                    className="dot-icon"
                    style={{
                      margin: collapsed ? "0px" : "0px 5px 0px 0px",
                    }}
                  />
                }
              >
<span style={{display: 'block', lineHeight: '1.2'}}>Progress Summary</span><span style={{display: 'block', lineHeight: '1.2'}}>Report</span>
              </Menu.Item>
            </>
          )}
        </SubMenu>
      );
    });
  };

  const projectControlMenuItem = (item) => {
    const { link } = item;

    return (
      <>
        <Menu.Item
          onClick={() =>
            setSelectProjectsModalVisible(!SelectProjectsModalvisible)
          }
          className={`subitems-custom select-project`}
          key={link}
          style={{
            padding: collapsed ? `0px !important` : "10px 15px 10px 45px",
            paddingLeft: collapsed ? "10px" : "42px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <span
                style={{
                  paddingLeft: "42px",
                }}
              >
                Select Projects
              </span>
            </div>
            <div>
              <DownOutlined className="dropdown-icon" />
            </div>
          </div>
        </Menu.Item>
        {!SelectProjectsModalvisible && <ProjectsList item={item} />}
      </>
    );
  };

  const menuSubItems = (item) => {
    const { name, link } = item;

    return (
      <Menu.Item
        onClick={() => navigate(link)}
        className="subitems-custom"
        key={link}
        style={{
          padding: collapsed ? `0px !important` : "10px 15px 10px 45px",
          paddingLeft: collapsed ? "10px" : "45px",
        }}
        icon={
          <DotIcon
            fill="#ffffff"
            className="dot-icon"
            style={{
              margin: collapsed ? "0px" : "0px 5px 0px 0px",
            }}
          />
        }
      >
        {name}
      </Menu.Item>
    );
  };

  return (
    <>
      {/* <NotificationChannel />
      <Notifications
        visible={notificationModalvisible}
        setVisible={setNotificationModalVisible}
      /> */}
      <SelectProjectsPopup
        visible={SelectProjectsModalvisible}
        setVisible={setSelectProjectsModalVisible}
        setSelectedProjects={setSelectedProjects}
        selectedProjects={selectedProjects}
      />
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? "70px" : `260px`}
        className={`main-sidebar${collapsed ? `-collapsed` : ""} `}
      >
        {shouldCollapse && (
          <span
            onClick={() => {
              setCollapsed(!collapsed);
              dispatch(setNavbarCollapsed(!collapsed));
            }}
            className="sidebar-pin-icon"
          >
            {collapsed ? <RightOutlined /> : <LeftOutlined />}
          </span>
        )}
        <div
          className="trigger sidebar-child-div"
          // onClick={() => shouldCollapse && setCollapsed(!collapsed)}
        >
          {collapsed ? (
            <div
              className="nav-collapsed-img-div"
              style={{
                margin: collapsed ? "20px 0" : "0px 10px",
              }}
              onClick={() => navigate("/")}
            >
              <img src={collapsedIcon} alt="" />
            </div>
          ) : (
            <div className="nav-uncollapsed-img-div">
              <img
                src={Logo}
                alt="Logo"
                style={{
                  margin: collapsed && "0px !important",
                }}
                onClick={() => navigate("/")}
              />
            </div>
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          className="sidebar-custom"
          defaultSelectedKeys={[location.pathname]}
          selectedKeys={[handleSelectedKey()]}
        >
          {menuItemsData.map((el) => {
            const {
              key,
              src,
              SvgImg,
              name,
              link,
              hasSubItems,
              subItems,
              hasPermission,
            } = el;

            return hasSubItems && hasPermission ? (
              <SubMenu
                className={`menu-item-for-top-border${
                  collapsed ? "-collapsed" : ""
                }`}
                key={key}
                icon={
                  <SvgImg
                    className="project-icon"
                    style={{
                      margin: collapsed ? "0px" : "0px 5px 0px 0px",
                    }}
                  />
                }
                title={
                  !collapsed && (
                    <span
                      className={` ${
                        key === "project-control" ? "" : "settings-title-span"
                      }`}
                    >
                      {name}
                    </span>
                  )
                }
              >
                {subItems?.map((el) => {
                  const { hasPermission, key } = el;

                  return (
                    hasPermission &&
                    (key === "project-control"
                      ? projectControlMenuItem(el)
                      : menuSubItems(el))
                  );
                })}
              </SubMenu>
            // ) : name === "notification" ? (
            //   !shouldCollapse && (
            //     <Menu.Item
            //       className="sidebar-notification-menu-item"
            //       onClick={(e) => {
            //         //   dispatch(fetchNotificationsList());
            //         setNotificationModalVisible(!notificationModalvisible);
            //       }}
            //       key={"/notification"}
            //       icon={
            //         <Badge count={unreadNotifications} overflowCount={9}>
            //           <BellFilled />
            //         </Badge>
            //       }
            //     ></Menu.Item>
            //   )
            ) : (
              el?.hasPermission && (
                <Menu.Item
                  onClick={() => navigate(link)}
                  key={link}
                  style={el.key === "1" && el.isNameTooLong ? { height: "80px" } : {}}
                  className={
                    link === "/profile" || link === "/client-profile"
                      ? `sidebar-custom-menuitem menu-item-for-top-border${
                          collapsed ? "-collapsed" : ""
                        }`
                      : `menu-item-for-top-border${
                          collapsed ? "-collapsed" : ""
                        }`
                  }
                  icon={
                    link === "/profile" || link === "/client-profile" ? (
                      <div className="sidebar-profile-icon">
                        <Avatar
                          shape={"circle"}
                          style={{
                            margin: collapsed ? "0px" : "0px 5px 0px 0px",
                          }}
                          src={src ? src : <UserIcon />}
                        />
                      </div>
                    ) : (
                      <Avatar
                        className="profile-avatar"
                        shape={"square"}
                        style={{
                          margin: collapsed ? "0px" : "0px 5px 0px 0px",
                        }}
                        src={
                          SvgImg ? <SvgImg className="profile-svg-icon" /> : src
                        }
                      />
                    )
                  }
                >
                  {link === "/profile" || link === "/client-profile" ? (
                    <div className="profile-menu-div">
                      <div className="profile-username-div">
                        {el.isNameTooLong ? (
                          <>
                            <p style={{ marginTop: 7, padding: 0, lineHeight: '1.1' }}>{el.firstName}</p>
                            <p style={{ margin: 0, padding: 0, lineHeight: '1.1' }}>{el.lastName}</p>
                          </>
                        ) : (
                          <p>{el.firstName} {el.lastName}</p>
                        )}
                        <span>{el.role}</span>
                      </div>
                      {!collapsed && (
                        <div
                          style={{
                            paddingRight: 12,
                            zIndex: 999999999999999,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            // dispatch(fetchNotificationsList());
                            setNotificationModalVisible((e) => !e);
                          }}
                        >
                          {/* <Badge count={unreadNotifications} overflowCount={9}>
                            <BellFilled className="notification-icon" />
                          </Badge> */}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="profile-menu-div">
                      {link === "/projects-setup" || (el.firstName === undefined && el.lastName === undefined) ? (
                        <div>{name}</div>
                      ) : el.isNameTooLong ? (
                        <div>
                          <div>{el.firstName}</div>
                          <div>{el.lastName}</div>
                        </div>
                      ) : (
                        <div>{el.firstName} {el.lastName}</div>
                      )}
                    </div>
                  )}
                </Menu.Item>
              )
            );
          })}
          <Menu.Item
            className={`sidebar-custom-menuitem menu-item-for-top-border${
              collapsed ? "-collapsed" : ""
            }`}
            style={{
              cursor: "default",
            }}
            key={"none"}
          ></Menu.Item>
          <Menu.Item
            onClick={() => !logoutLoading && handleLogout()}
            className={`sidebar-custom-menuitem menu-item-for-top-border${
              collapsed ? "-collapsed" : ""
            } logout-menu-item`}
            key={"logout"}
            icon={<LogoutOutlined />}
          >
            Logout {logoutLoading && "..."}
          </Menu.Item>
        </Menu>
      </Sider>
    </>
  );
};
export default SidebarComponent;
